declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ApiRequestModel } from '../../../models/api_request_model';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../../services/hcp.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ActorService } from '../../../services/actor.service';
import { FDService } from '../../../services/fd.service';
import { ConsultantMapPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { SaveMaterialBatchInfoRequest, SaveMaterialBatchRequest, GenericProcPostRequest, S_Methods, SaveMaterialDetailsInfoRequest, EditMaterialDetailsInfoRequest, LongCodeTypeValueController, LongCodeTypeValueRequest, SaveCodeTypeValueRequest, DeleteCodeTypeValueRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { NgbEditCodetypeValue2Modal } from './editcodetypevalue2.modal';

@Component({
  selector: 'ngbeditcodetypevalue',
  templateUrl: './editcodetypevalue.modal.html',
  styleUrls: ['./editcodetypevalue.modal.scss']
})

export class NgbEditCodetypeValueModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  public isRequesting: boolean;
  @Input() CodeType: string;
  @Input() MaterialSpec: number;
  @Input() HsnCode: string;
  @Input() GroupName: string;
  @Input() GroupCode: number;
  @Input() SaleUOM: string;
  @Input() TaxPercent: number;
  @Input() PurchaseUOM: string;

  public UpdatedDescription: string;
  public UpdatedMaterialSpec: number;
  public UpdatedHsnCode: string;
  public UpdatedGroupName: string;
  public UpdatedTaxPercent: number;
  public UpdatedSaleUOM: string;
  public UpdatedPurchaseUOM: string;

  //ExpiryDate: NgbDateStruct;
  public ApiResData: ApiResponseModel;
  CurrentSaveCodeTypeValueRequest: SaveCodeTypeValueRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  ngOnInit() {
    this.LoadCodeValues();
    this.CurrentSaveCodeTypeValueRequest = new SaveCodeTypeValueRequest();
    this.CurrentSaveCodeTypeValueRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.UpdatedMaterialSpec = this.MaterialSpec;
    this.UpdatedHsnCode = this.HsnCode;    
    //this.UpdatedGroupName = this.GroupName;
    this.UpdatedTaxPercent = this.TaxPercent;
    this.UpdatedSaleUOM = this.SaleUOM;
    this.UpdatedPurchaseUOM = this.PurchaseUOM;
    this.MaterialGroupCode = this.GroupCode;
}
  CurrentLongCodeTypeValueController: LongCodeTypeValueController[];
  SelectedLongCodeTypeValueController: LongCodeTypeValueController;
  CurrentLongCodeTypeValueRequest: LongCodeTypeValueRequest;
  CurrentEditLongCodeTypeValueRequest: LongCodeTypeValueRequest;
  LoadCodeValues() {
    this.CurrentLongCodeTypeValueRequest = new LongCodeTypeValueRequest();
    this.CurrentLongCodeTypeValueRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata2 = this.CurrentLongCodeTypeValueController;
    this.CurrentLongCodeTypeValueRequest.ConditionalOperator = 10;
    this.CurrentLongCodeTypeValueRequest.CodeTypeValueCode = 0;
    this.CurrentLongCodeTypeValueRequest.LongValue = "";
    this.CurrentLongCodeTypeValueRequest.ShortValue = "";
    this.CurrentLongCodeTypeValueRequest.CodeType = this.CodeType.toString();
    this.CurrentLongCodeTypeValueRequest.ParentValue = "";
    this.CurrentLongCodeTypeValueRequest.SeqNo = 0;
    this.GetLongCodeTypeValueController();
  }
  GetLongCodeTypeValueController() {
    this.StartRefreshing();
    this.actorservice.GetLongCodeTypeValueController(this.CurrentLongCodeTypeValueRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentLongCodeTypeValueController = this.ApiResData.Result;
          this.SelectedLongCodeTypeValueController = this.ApiResData.Result;
          //this.pdata2 = this.CurrentLongCodeTypeValueController;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }
      );
  }
  EditCodeType(l) {
    const modalRef = this.modalService.open(NgbEditCodetypeValue2Modal,
      {
        centered: true

      })
    modalRef.componentInstance.CodeType = l.CodeType;
    modalRef.componentInstance.Code = l.Code;
    modalRef.componentInstance.LongValue = l.LongValue;
    modalRef.componentInstance.ShortValue = l.ShortValue;
    modalRef.result.then(x => { this.LoadCodeValues() })
  }
  public LongValue: string;
  public ShortValue: string;
  SaveCodeTypeValue() {
    if (!this.LongValue || !this.ShortValue) {
      alertFunctions.AlertParam("Please enter both Long Value and Short Value.");
      return;
    }
    this.StartRefreshing();
    var saveReq = new SaveCodeTypeValueRequest();
    saveReq.ConditionalOperator = 1;
    saveReq.CodeType = this.CodeType;
    saveReq.LongValue = this.LongValue;
    saveReq.ShortValue = this.ShortValue;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.SaveCodeTypeValues(saveReq).subscribe(
      (result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.LongValue = '';
          this.ShortValue = '';
          this.LoadCodeValues();
        } else {
          this.stopRefreshing();
          alertFunctions.AlertParam(this.ApiResData.ErrorData || "Failed to save.");
        }
      },
      (error) => {
        this.stopRefreshing();
        alertFunctions.AlertParamEr(error);
      }
    );
  }
  DeleteCodeType(l) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {
      this.DeleteCodeTypeValue(l);
    }, function (dismiss) {
      if (dismiss === 'cancel') {
        swal('Cancelled', 'Delete Operation Cancelled :)', 'error');
      }
    });
  }
  DeleteCodeTypeValue(l) {
    this.StartRefreshing();
    var saveReq = new SaveCodeTypeValueRequest();
    saveReq.ConditionalOperator = 3;
    saveReq.CodeTypeValueCode = l.Code;
    saveReq.CodeType = l.CodeType;
    saveReq.LongValue = l.LongValue;
    saveReq.ShortValue = l.ShortValue;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.SaveCodeTypeValues(saveReq).subscribe(
      (result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.tosterservice.ToasterSuccessAlertParam('Deleted Successfully.....!');
          this.stopRefreshing();
          this.LoadCodeValues();
        } else {
          this.stopRefreshing();
          alertFunctions.AlertParam(this.ApiResData.ErrorData || "Failed to delete.");
        }
      },
      (error) => {
        this.stopRefreshing();
        alertFunctions.AlertParamEr(error);
      }
    );
  }
  MaterialGroupCode: number = 0;
  public MaterialGroupName: string;
  onAssignedToActorCodesurgeon2(event: any) {

    if (event != null) {
      this.MaterialGroupName = event;
    }

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
